export default "__VITE_ASSET__6c2aafae__"